// extracted by mini-css-extract-plugin
export default {"loadingContainer":"Loading_loadingContainer__auLAM","spinner":"Loading_spinner__SSVGA","spin":"Loading_spin__F5PJo","message":"Loading_message__y8Mo-"};